import * as React from 'react';

import {VerticalTabs} from 'shells/tabs/vertical-tabs/vertical-tabs';

import type {GetActivityForModal_activity as ActivityForModal} from 'nutshell-graphql-types';

import {getTabs} from './helpers';
import type {ModalVariant} from './types';

import styles from './activity-modal.module.css';

type SidebarProps = {
    activeTab: string;
    setActiveTab: (tab: string) => void;
    activity: ActivityForModal | null | undefined;
    variant: ModalVariant;
};

export function Sidebar(props: SidebarProps) {
    const {variant, activity} = props;
    const commentCount = activity && activity.comments.totalCount;

    const tabs = React.useMemo(
        () => getTabs(variant, activity, commentCount),
        [variant, activity, commentCount]
    );

    return (
        <div className={styles['activity-modal-sidebar']}>
            <VerticalTabs
                tabs={{
                    options: tabs,
                    selectedTab: props.activeTab,
                    onChangeTab: (id: string) => {
                        props.setActiveTab(id);
                    },
                }}
            />
        </div>
    );
}
